import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import colors from 'src/config/colors'
import { BUTTON_WIDTH } from 'src/config/styles'

export default createUseStyles({
  wrapper: {
    margin: '0 auto',
    width: '60%',
    padding: '50px 0',
    [forPhoneOnly]: {
      width: '80vw',
      background: colors.white,
    },
  },
  innerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  contentWrapper: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 418,
    marginTop: 24,
    padding: '0 16px',
    [forPhoneOnly]: {
      marginTop: 16,
    },
  },
  buttonWrapper: {
    marginTop: 40,
    width: BUTTON_WIDTH,
    [forPhoneOnly]: {
      width: '100%',
      margin: 0,
    },
  },
})
